module.exports = __webpack_public_path__ + "img/7193d4f.png";